import * as yup from 'yup';

import { FILE_TYPES } from 'app/components/Employees/ImportEmployees/types';

export const importEmployeesCompanyFormSchema = yup.object().shape({
  companyId: yup.string().required('You need to select a company'),
});

export const importEmployeesPayCalendarFormSchema = yup.object().shape({
  payCalendarId: yup.string().required('You need to select a pay calendar'),
});

export const importEmployeesFileTypeFormSchema = yup.object().shape({
  fileType: yup
    .string()
    .oneOf(Object.values(FILE_TYPES), 'You need to select a file type')
    .required('You need to select a file type'),
});

export const importEmployeesUploadFormSchema = yup.object().shape({
  bulkImportId: yup.string().required('You need a bulk import to advance'),
  bulkImportStatus: yup.string().required('You need a bulk import to advance'),
});

// AET-specific confirmation schema
export const aetConfirmDataFormSchema = yup.object().shape({
  aetFileId: yup.string().required('AET file ID is required'),
  aetFileStatus: yup.string().required('AET file status is required'),
  newEarningsCount: yup.number().min(0, 'New earnings count must be non-negative'),
  changedEarningsCount: yup.number().min(0, 'Changed earnings count must be non-negative'),
  payPeriod: yup.object().shape({
    startDate: yup.string().required('Pay period start date is required'),
    endDate: yup.string().required('Pay period end date is required'),
  }),
  payday: yup.string().required('Payday is required'),
});
